export function patchOptionsWithAuthHeader(options, token) {
  if (!token) return;

  if (!options.headers) {
    options.headers = {};
  }

  options.headers.Authorization = `Bearer ${token}`;
}
